import { useState, useEffect } from 'react';
import config from '../../config.json';
import { theme } from '../../styles';
import { Main, MainContent, SideNav, NavText, Title } from '../../components';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ArrowOutwardIcon } from '../../assets/svg';
import { Button, ButtonIcon} from '../../components';

const Clients = () => {
  const [active, setActive] = useState('');
  const [clients, setClients] = useState(config.clients.reduce((acc, client) => ({...acc, [client.name]: {
    element: (<NavText>{client.name}</NavText>), work: client.work
  }}), {}) );
  
  useEffect(() => {
    setActive(Object.keys(clients)[0]);
  }, [clients])
  return (
    <Main
      $flexDirection='row'
      animate={theme.fadeIn.animate}
      exit={theme.fadeIn.initial}
      transition={theme.fadeIn.transition(0)}
    >
      <SideNav
        active={active}
        items={
          clients
         }
        handleSelect={select => setActive(select)}
      />
      <MainContent
        initial={theme.fadeIn.initial}
        animate={theme.fadeIn.animate}
        transition={theme.fadeIn.transition(theme.delaySm)}
      >
    <Title>
      <ClientTitle>
      {active && 
      <>
        <ClientProfile src={require(`../../assets/clients/${active}/profile.png`)} alt={active}/>
        {active}
        </>
        }
      </ClientTitle>
    </Title>
    {
      active && clients[active].work.map(work => (
        <WorkCard>
          <img src={require(`../../assets/clients/${active}/${work.thumbnail}.png`)} alt={work.thumbnail} />
          <CardBody>
          <h6>{work.title}</h6>
          <p>{work.description}</p>
          { work.link && <Button
            type="Link"
            style="outline"
            color="brand"
            size="sm"
            width="fit-content"
            to={work.link}
            target="blank"
          >
            See more
          </Button>}
          </CardBody>
        </WorkCard>
      ))
    }
      </MainContent>
    </Main>
  );
};

export default Clients;

const ClientProfile = styled.img`
  width: 4rem;
  height: 4rem; 
  object-fit: cover;
  border-radius: 6rem;
`;

const WorkCard = styled.div`
  display: flex;
  gap: ${props => props.theme.spaceMd};
  background-color: ${props => props.theme.backgroundColor};
  padding: ${props => props.theme.spaceMd};
  width: 100%;  
  border-radius: ${props => props.theme.borderRadiusMd};

  & img {
    min-width: 8rem;
    min-height: 8rem;
    width: 8rem;
    height: 8rem;
  border-radius: ${props => props.theme.borderRadiusSm};
    object-fit: cover;
  }
`

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceSm};

  a {
    margin-left: 0;
    margin-right: 0;
    margin-top: auto;
  }
`
const ClientTitle = styled.span`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spaceMd};
  align-items: center;

`